/**
 * Function find constructions %[key] (%example) in source string and replace it by data
 * @param str - source string
 * @param data - object with replace data where:
 *  key - replace info key (without "%" symbol)
 *  value - info that we want to replace
 * @returns string
 */
export const replace = function (str, data) {
  return str.replace(/%([a-zA-Z]+)/gi, (x, key) => data[key] || x)
}
